import React, { useEffect, useState } from "react";
import Chatbot from "react-chatbot-kit";
import config from "../chatbot/config";
import MessageParser from "../chatbot/MessageParser";
import ActionProvider from "../chatbot/ActionProvider";
import { AiOutlineWechat } from "react-icons/ai";
import { AiOutlineCloseCircle } from "react-icons/ai";
import "react-chatbot-kit/build/main.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const Bot = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const saveMessages = (messages) => {
    localStorage.setItem("chat_messages", JSON.stringify(messages));
  };

  useEffect(() => {
    setOpen(false);
  }, [location]);

  let index = 1;
  const validateInput = (messages) => {
    if (
      index === 1 &&
      String(messages.toLowerCase())
        .toLowerCase()
        // .match(
        //   /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        // )
    ) {
      index++;
      return true;
    } else if (
      index === 2 &&
      messages.match(
        /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
      ) &&
      Array.from(messages).length < 20 &&
      Array.from(messages).length > 7
    ) {
      index++;
      return true;
    } else if (index === 3) {
      return true;
    } else if (
      index === 1 &&
      !String(messages.toLowerCase())
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      toast.error(t("Please Enter A Valid Email"));
    } else if (index === 2 && Array.from(messages).includes(" ")) {
      toast.error(t("Please remove the spaces from the Number"));
    } else if (index === 2 && Array.from(messages).length > 7) {
      toast.error(t("Phone Number Should be Grater Then 7 digits"));
    }
    //  else if (
    //   index === 2 &&
    //   !messages.match(
    //     /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
    //   )
    // ) {
    //   toast.error(
    //     t("Please Enter A Valid Phone Number or Less Then 15 Digits")
    //   );
    // } 
    else if (index === 2 && Array.from(messages).length > 20) {
      toast.error(t("Please Enter Less Then 15 Digits Phone Number"));
    }
  };

  return (
    <div className="appChatbotContainer">
      <button
        className="appChatbotButton"
        onClick={() => setOpen((prev) => !prev)}
      >
        <AiOutlineWechat
          size={29}
          style={{ marginBottom: "-13px" }}
          color="white"
        />
        <span className="text-light mb-4">{t("Chat")}</span>
      </button>
      {open && (
        <Chatbot
          config={config}
          messageParser={MessageParser}
          actionProvider={ActionProvider}
          saveMessages={saveMessages}
          placeholderText={t("Write your message here")}
          validator={validateInput}
          headerText={
            <div className="d-flex w-100 justify-content-between align-items-center">
              {t("Conversation with Invozio AI")}
              <AiOutlineCloseCircle
                className="cursor-pointer"
                size={18}
                onClick={() => setOpen(false)}
              />
            </div>
          }
        />
      )}
    </div>
  );
};

export default Bot;
